import { getRegions } from '@luxuryescapes/lib-regions';

/** Region codes available on the Luxury Escapes site (from lib-regions). */
export const SITE_REGION_CODES: Array<string> = getRegions()
  .map((region) => region.code)
  .sort((a, b) => a.localeCompare(b));

export function isSiteRegionCode(code: string): boolean {
  return SITE_REGION_CODES.includes(code);
}

export function filterToSiteRegionCodes(codes: Array<string>): Array<string> {
  return codes.filter(isSiteRegionCode);
}
